import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { AllianzProcessPayload, AllianzProcessPayloadSchema } from './insurance-cover.process.payload';
import { AnnualBankRevenueProcessPayloadSchema, AnnualBankRevenueProcessPayload } from './annual.bank.revenue.process.payload';
import { BankFinancialConnectionProcessPayload } from './bank.financial.connection.process.payload';
import { BusinessStartDateProcessPayloadSchema, BusinessStartDateProcessPayload } from './business.start-date.process.payload';
import BusinessVerificationProcessPayload from './business.verification.process.payload';
import { CreditScoreProcessPayloadSchema, CreditScoreProcessPayload } from './credit.score.process.payload';
import { PersonalGuaranteeProcessPayload } from './personal.guarantee.process.payload';
import { AccountBalanceProcessPayload } from './account.balance.process.payload';
import { AvailableBankActivityProcessPayload } from './available.bank.activity.process.payload';
import { BankRevenueToRequestedCreditRatioProcessPayload } from './bank-revenue.to.requested-credit.ratio.process.payload';
import { DebtAmountProcessPayload } from './debt.amount.process.payload';
import { NetProfitProcessPayload } from './net.profit.process.payload';
import { TransactionsPerMonthProcessPayload } from './transactions.per-month.process.payload';
import { DebtRepaymentToMonthlyBankRevenueRatioProcessPayload } from './debt-repayment.to.monthly.bank-revenue.ratio.process.payload';
import { IdentityVerificationProcessPayload } from './identity-verification.process.payload';
import { BondRatingProcessPayload } from './bond-rating.process.payload';
import { ReliabilityProcessPayload } from './reliability.process.payload';
import { NegativeBalanceDaysProcessPayload } from './negative.balance-days.process.payload';
import { NsfOverdraftProcessPayload } from './nsf.overdraft.process.payload';

export enum ProcessResultStatus {
    Success = 'success',
    Failed = 'failed',
    Pending = 'pending',
    Unknown = 'unknown',
}

export const ProcessResultSchema = z.object({
    payload: z
        .union([
            z.object({}),
            CreditScoreProcessPayloadSchema,
            AllianzProcessPayloadSchema,
            AnnualBankRevenueProcessPayloadSchema,
            BusinessStartDateProcessPayloadSchema,
        ])
        .nullish(),
    status: EnumSchema(ProcessResultStatus),
});

export class ProcessResult extends FromSchema(ProcessResultSchema) {
    status: ProcessResultStatus;
    payload?:
        | PersonalGuaranteeProcessPayload
        | AllianzProcessPayload
        | CreditScoreProcessPayload
        | AnnualBankRevenueProcessPayload
        | BusinessVerificationProcessPayload
        | BusinessStartDateProcessPayload
        | BankFinancialConnectionProcessPayload
        | AccountBalanceProcessPayload
        | AvailableBankActivityProcessPayload
        | BankRevenueToRequestedCreditRatioProcessPayload
        | DebtRepaymentToMonthlyBankRevenueRatioProcessPayload
        | DebtAmountProcessPayload
        | NetProfitProcessPayload
        | TransactionsPerMonthProcessPayload
        | IdentityVerificationProcessPayload
        | NsfOverdraftProcessPayload
        | NegativeBalanceDaysProcessPayload
        | ReliabilityProcessPayload
        | BondRatingProcessPayload;
}
